module.exports = __webpack_public_path__ + "img/asset.e727a334.svg";